export const BILLING_STATUS = {
    READY: 1,
    SUBMITTED: 2,
    PROCESSING: 3,
    REJECTED: 4,
  };
  
  export const BILLING_STATUS_LABELS = {
    [BILLING_STATUS.READY]: 'Ready',
    [BILLING_STATUS.SUBMITTED]: 'Submitted',
    [BILLING_STATUS.PROCESSING]: 'Processing',
    [BILLING_STATUS.REJECTED]: 'Rejected',
  };
  export const TIMELOG_STATUS = {
    NOTCONFIRMED: 0,
    CONFIRMED: 1
  };
  
  export const TIMELOG_STATUS_LABELS = {
    [TIMELOG_STATUS.NOTCONFIRMED]: 'Not Confirmed',
    [TIMELOG_STATUS.CONFIRMED]: 'Confirmed'
  };